import { graphql } from 'src/graphql';

export const ChatFeedbacks = graphql(`
  query GetChatFeedbacks($chatMessageIds: [String!]!) {
    chatFeedbacks(chatMessageIds: $chatMessageIds) {
      id
      createdAt
      updatedAt
      chatMessageId
      userId
      teamId
      type
      issueType
      details
    }
  }
`);
